<form [formGroup]="formGroup">
  <table class="lum-table lum-table--classic striped">
    <thead>
      <tr>
        <th>
          Custom Field Property
          <button
            class="btn btn-sm btn-secondary"
            type="button"
            (click)="onAddField()"
          >
            <i class="fas fa-plus"></i> Add Custom Field
          </button>
        </th>
        <th>Custom Field Value</th>
        <th width="1">&nbsp;</th>
      </tr>
    </thead>
    <tbody formArrayName="pushCustomFields">
      <tr
        *ngFor="let item of channelPushCustomFields.controls; let idx = index"
        [formGroupName]="idx"
      >
        <td class="text-right">
          <input type="text" formControlName="key" class="lum-input" />
        </td>
        <td class="text-right">
          <input type="text" formControlName="value" class="lum-input" />
        </td>

        <td>
          <a href="javascript:;" (click)="onRemoveField(idx)" title="Remove row">
            <mat-icon [width]="16" [height]="16" color="#f24f63">delete</mat-icon>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</form>
